import { render, staticRenderFns } from "./goodssku-add-or-update.vue?vue&type=template&id=073d0b4a&"
import script from "./goodssku-add-or-update.vue?vue&type=script&lang=js&"
export * from "./goodssku-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./goodssku-add-or-update.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports